var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_693_1391",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_693_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M9.99992 9.99984C10.4583 9.99984 10.8506 9.83664 11.177 9.51025C11.5034 9.18387 11.6666 8.7915 11.6666 8.33317C11.6666 7.87484 11.5034 7.48248 11.177 7.15609C10.8506 6.8297 10.4583 6.6665 9.99992 6.6665C9.54158 6.6665 9.14922 6.8297 8.82284 7.15609C8.49645 7.48248 8.33325 7.87484 8.33325 8.33317C8.33325 8.7915 8.49645 9.18387 8.82284 9.51025C9.14922 9.83664 9.54158 9.99984 9.99992 9.99984ZM9.99992 16.1248C11.6944 14.5693 12.9513 13.1561 13.7708 11.8853C14.5902 10.6144 14.9999 9.48595 14.9999 8.49984C14.9999 6.98595 14.5173 5.74637 13.552 4.78109C12.5867 3.81581 11.4027 3.33317 9.99992 3.33317C8.59714 3.33317 7.41311 3.81581 6.44784 4.78109C5.48256 5.74637 4.99992 6.98595 4.99992 8.49984C4.99992 9.48595 5.40964 10.6144 6.22909 11.8853C7.04853 13.1561 8.30547 14.5693 9.99992 16.1248ZM9.99992 18.3332C7.76381 16.4304 6.09367 14.663 4.9895 13.0311C3.88534 11.3991 3.33325 9.88873 3.33325 8.49984C3.33325 6.4165 4.00339 4.75678 5.34367 3.52067C6.68395 2.28456 8.23603 1.6665 9.99992 1.6665C11.7638 1.6665 13.3159 2.28456 14.6562 3.52067C15.9964 4.75678 16.6666 6.4165 16.6666 8.49984C16.6666 9.88873 16.1145 11.3991 15.0103 13.0311C13.9062 14.663 12.236 16.4304 9.99992 18.3332Z",
    fill: "url(#paint0_linear_693_1391)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_693_1391",
    x1: 9.99992,
    y1: 1.6665,
    x2: 9.99992,
    y2: 18.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8f0558a01915a255c168657ddfabd63d.svg";
export { ForwardRef as ReactComponent };